import { useEffect } from "react";

const SITE_NAME = "ZenFresh";

/** Sets the browser tab title for the page it's called in, restoring the previous title on unmount. */
export default function useDocumentTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} — ${SITE_NAME}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
